import React, { useEffect, useState } from "react";
import { CustomButton } from "../../../../components/customButton/CustomButton";
import { CustomInput } from "../../../../components/customInput/CustomInput";
import {
  BankIcon,
  EditPencil,
  UpiIcon,
} from "../../../../resources/assetsManager";
import {
  BG_COLOR,
  BLACK_COLOR,
  LIGHT_GREY_BG_MODAL,
  WHITE_COLOR,
} from "../../../../resources/colorsManager";
import "../index.css";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import CustomDatePicker from "../../../../components/custom_date_picker";
import CustomModal from "../../../../components/customModal/CustomModal";
import AddCustomerForUpiModal from "./AddCustomerForUpiModal";
import AddAccountModal from "./AddAccountModal";
import { connect, useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import UpdateUpiModal from "./UpdateUpiModal";
import { removeAllAccountsAction } from "../../../../../data/redux/action/add_customer/addAccountsAction";
import { ApiRequestPost } from "../../../../../data/network/services/ApiRequestPost";
import { SUCCESS } from "../../../../resources/constantsManager";
import UpdateConfirmUpi from "./UpdateConfirmUpi";

const RowContainer = ({ value, title }) => {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <p
        style={{
          fontSize: 12,
          color: BLACK_COLOR,
          padding: 0,
          margin: 0,
          marginRight: 20,
        }}
      >
        {title}
      </p>
      <p
        style={{
          fontSize: 12,
          color: "#494949",
          padding: 0,
          margin: 0,
        }}
      >
        {value}
      </p>
    </div>
  );
};
function UpiDetails({ allAccounts, data, onClose, profileDetails }) {
  const [virtualId, setVirtualId] = useState("");
  const [disableBeforeVID, setDisableBeforeVID] = useState(true);
  const [showAdvancedOptions, setShowAdvancedOptions] = useState(false);
  const [showAddAccountModal, setShowAddAccountModal] = useState(false);
  const [showAddUpiModal, setShowAddUpiModal] = useState(false);
  const [upiSelected, setUpiSelected] = useState(false);
  const [bankTransferSelected, setBankTransferSelected] = useState(false);
  const [disableAutoClose, setDisableAutoClose] = useState(false);
  const [updateVidModal, setUpdateVidModal] = useState(false);
  const [confirmUpiModal, setShowConfirmUpiModal] = useState(false);
  const [closeByDate, setCloseByDate] = useState("");
  const [userUpiDetails, setUserUpiDetails] = useState([]);
  const [editedUpi, setEditedUpi] = useState("");
  const [minDate, setMinDate] = useState("");
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const upiCommonBankName = "@yesbankltd";
  const upiCommonNumber = profileDetails?.accountNumber;
  const inputStyle = {
    backgroundColor: BG_COLOR,
    alignSelf: "center",
    marginBottom: 15,
    height: 50,
    width: "100%",
    boxShadow: "none",
  };

  const onClickAddCustomerUPI = () => {
    setIsLoading(true);
    ApiRequestPost.addCustomers({
      firstName: data[0]?.firstName,
      lastName: data[0]?.lastName,
      autoCloseStatus: !disableAutoClose,
      closeByDate: disableAutoClose ? "" : closeByDate,
      mobileNumber: data[0]?.mobileNumber,
      bankDetails: allAccounts,
      paymentDetails: [
        {
          paymentMode: upiSelected ? "UPI" : "VAN",
          paymentId: `${upiCommonNumber}${virtualId}${upiCommonBankName}`,
          upiDetails: {
            merchantName: userUpiDetails[0]?.merchantName,
            mcc: "6540",
            brandName: userUpiDetails[0]?.brandName,
            legalName: "Neokred Technologies Private Limited",
            franchise: "NEOKRED",
            merchantType: "LARGE",
            ownerShipType: "PRIVATE",
            genre: "ONLINE",
            onboardingType: "Aggregator",
          },
        },
      ],
    })
      .then((res) => {
        console.log(res);
        if (res.status === SUCCESS) {
          enqueueSnackbar(res.message, {
            variant: "success",
          });
          onClose();
        } else {
          enqueueSnackbar(res.message, {
            variant: "error",
          });
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        enqueueSnackbar(err.message, {
          variant: "error",
        });
        setIsLoading(false);
      });
  };

  const validationCheckBeforeUpi = () => {
    if (allAccounts.length === 0) {
      enqueueSnackbar("Please configure third party validation", {
        variant: "error",
      });
    } else if (closeByDate === "" && !disableAutoClose) {
      enqueueSnackbar("Please select close by date", {
        variant: "error",
      });
    } else onClickAddCustomerUPI();
  };

  const validationCheck = () => {
    if (allAccounts.length === 0) {
      enqueueSnackbar("Please configure third party validation", {
        variant: "error",
      });
    } else if (closeByDate === "" && !disableAutoClose) {
      enqueueSnackbar("Please select close by date", {
        variant: "error",
      });
    }
  };

  useEffect(() => {
    dispatch(removeAllAccountsAction([]));
  }, []);

  useEffect(() => {
    const today = new Date();
    let tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);
    setMinDate(tomorrow);
  }, []);
  return (
    <div
      style={{
        width: "100%",
        maxHeight: 500,
        overflow: "scroll",
      }}
    >
      <p
        style={{
          fontSize: 14,
          color: "#888888",
          fontFamily: "Roboto",
        }}
      >
        Method to accept payment in this account
      </p>

      <p
        style={{
          fontSize: 14,
          color: "#888888",
          fontFamily: "Roboto",
        }}
      >
        Add Virtual ID
      </p>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 0,
          margin: 0,
          backgroundColor: BG_COLOR,
          margin: 0,
          height: 45,
          borderRadius: 5,
          maxWidth: 350,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: "100%",
            justifyContent: "center",
            padding: "0px 10px",
          }}
        >
          <p
            style={{
              padding: 0,
              margin: 0,
              fontSize: 14,
              letterSpacing: 1.2,
            }}
          >
            {profileDetails?.accountNumber}
          </p>
        </div>
        <CustomInput
          value={virtualId}
          onChange={(val) => {
            setVirtualId(val);
          }}
          type="input"
          validator="alphaNum"
          inputStyles={{
            ...inputStyle,
            backgroundColor: WHITE_COLOR,
            border: "none",
            margin: 0,
            padding: "10px 10px",
            height: 35,
            margin: "0px 10px",
            fontSize: 13,
            borderRadius: 3,
            minWidth: 100,
          }}
          placeholder="upto 10 digits"
          className="input-1"
          maxLength={10}
          disabled={!disableBeforeVID}
        />
      </div>

      <CustomButton
        title={disableBeforeVID ? "Confirm" : "Saved"}
        styles={{
          border: "none",
          marginTop: 10,
          borderRadius: 4,
          backgroundColor: disableBeforeVID ? "#3783FB" : "#0CC758",
        }}
        onClick={() => {
          if (virtualId.length > 1) {
            setDisableBeforeVID(false);
          } else {
            enqueueSnackbar("Please enter Virtual ID", {
              variant: "error",
            });
          }
        }}
      />

      <div
        style={{
          marginTop: 20,
          opacity: disableBeforeVID ? 0.3 : 1,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <input
            type="checkbox"
            style={{
              height: 17,
              width: 17,
              cursor: "pointer",
            }}
            disabled={disableBeforeVID}
            onChange={() => {
              setBankTransferSelected(!bankTransferSelected);
            }}
            value={bankTransferSelected}
          />
          <img
            src={BankIcon}
            style={{
              margin: "0px 10px 0px 20px",
            }}
          />

          <p
            style={{
              padding: 0,
              margin: 0,
              fontSize: 14,
            }}
          >
            Bank Transfers (NEFT , RTGS , IMPS){" "}
          </p>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
          }}
        >
          {bankTransferSelected && (
            <div
              style={{
                backgroundColor: BG_COLOR,
                padding: "10px 15px",
                width: "90%",
                minWidth: 200,
                maxWidth: 300,
                marginLeft: 40,
                marginTop: 10,
                marginBottom: 10,
              }}
            >
              <RowContainer value={data[0]?.firstName} title="Name" />
              <RowContainer
                value={`${upiCommonNumber}${virtualId}`}
                title="VAN"
              />
              <RowContainer value="YESBNK00041" title="IFSC" />
            </div>
          )}
        </div>

        <div
          style={{
            display: "flex",
            marginTop: 5,
            flexDirection: "column",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            <input
              type="checkbox"
              style={{
                height: 17,
                width: 17,
                cursor: "pointer",
              }}
              disabled={disableBeforeVID}
              onChange={() => {
                setUpiSelected(!upiSelected);
              }}
              value={upiSelected}
            />
            <img
              src={UpiIcon}
              style={{
                margin: "0px 10px 0px 20px",
              }}
            />

            <p
              style={{
                padding: 0,
                margin: 0,
                fontSize: 14,
              }}
            >
              UPI Transfers (Gpay , Phonepay ,etc){" "}
            </p>
          </div>

          <div
            style={{
              display: "flex",
            }}
          >
            {!disableBeforeVID && (
              <div
                style={{
                  backgroundColor: BG_COLOR,
                  padding: "10px 15px",
                  width: "90%",
                  minWidth: 200,
                  maxWidth: 300,
                  marginLeft: 40,
                  marginTop: 10,
                  marginBottom: 10,
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <RowContainer
                  value={`${upiCommonNumber}${virtualId}${upiCommonBankName}`}
                />

                {upiSelected && (
                  <img
                    src={EditPencil}
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setUpdateVidModal(true);
                    }}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <div
        style={{
          height: 1,
          backgroundColor: "#F3F3F3",
          margin: "15px 0px",
        }}
      ></div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          opacity: disableBeforeVID ? 0.3 : 1,
        }}
      >
        <div>
          <p
            style={{
              padding: 0,
              margin: 0,
              fontSize: 14,
              color: BLACK_COLOR,
              fontFamily: "Roboto",
            }}
          >
            {showAdvancedOptions
              ? "Hiide Advance Options"
              : "View Advance Options"}
          </p>
          <p
            style={{
              padding: 0,
              margin: 0,
              fontSize: 14,
              color: "#888888",
              fontFamily: "Roboto",
            }}
          >
            {!showAdvancedOptions &&
              "Third party Validation, Auto Close, Description ect"}
          </p>
        </div>
        {showAdvancedOptions ? (
          <IoIosArrowUp
            style={{
              color: "dodgerblue",
              cursor: !disableBeforeVID && "pointer",
            }}
            onClick={() => {
              !disableBeforeVID && setShowAdvancedOptions(false);
            }}
          />
        ) : (
          <IoIosArrowDown
            style={{
              color: "dodgerblue",
              cursor: !disableBeforeVID && "pointer",
            }}
            onClick={() => {
              !disableBeforeVID && setShowAdvancedOptions(true);
            }}
          />
        )}
      </div>

      {showAdvancedOptions && (
        <div
          style={{
            marginTop: 40,
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              borderTop: "1px solid #F3F3F3",
              borderBottom: "1px solid #F3F3F3",
              padding: "15px 0px",
              width: "100%",
            }}
          >
            <div>
              <p
                style={{
                  padding: 0,
                  margin: 0,
                  fontSize: 14,
                  color: BLACK_COLOR,
                  fontFamily: "Roboto",
                }}
              >
                Third Party Validation
              </p>
              {allAccounts.length === 0 ? (
                <p
                  style={{
                    padding: 0,
                    margin: 0,
                    fontSize: 14,
                    color: "#888888",
                    fontFamily: "Roboto",
                  }}
                >
                  Not Configured
                </p>
              ) : (
                <p
                  style={{
                    padding: 0,
                    margin: 0,
                    fontSize: 14,
                    color: "#888888",
                    fontFamily: "Roboto",
                  }}
                >
                  {allAccounts.length} account added
                </p>
              )}
            </div>

            <p
              style={{
                color: allAccounts.length === 10 ? "lightgrey" : "dodgerblue",
                cursor: "pointer",
                fontSize: 14,
              }}
              onClick={() => {
                if (allAccounts.length === 10) {
                } else setShowAddAccountModal(true);
              }}
            >
              Configure
            </p>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              borderTop: "1px solid #F3F3F3",
              borderBottom: "1px solid #F3F3F3",
              padding: "15px 0px",
              pointerEvents: disableAutoClose && "none",
              opacity: disableAutoClose ? 0.5 : 1,
            }}
          >
            <p
              style={{
                padding: 0,
                margin: 0,
                fontSize: 14,
                color: "#888888",
                fontFamily: "Roboto",
              }}
            >
              Close By
            </p>

            <CustomDatePicker
              onChangeDate={(date) => {
                console.log(date);
                setCloseByDate(date);
              }}
              datePlaceholder="DD-MM-YYYY"
              style={{
                maxWidth: 150,
                backgroundColor: BG_COLOR,
              }}
              minDate={minDate}
            />
          </div>

          <div
            style={{
              //   position: "sticky",
              //   bottom: 0,
              backgroundColor: WHITE_COLOR,
              zIndex: 1000,
              pointerEvents: closeByDate !== "" && "none",
              opacity: closeByDate !== "" ? 0.5 : 1,
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: 5,
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "flex",
                }}
              >
                <input
                  type="checkbox"
                  style={{
                    height: 17,
                    width: 17,
                  }}
                  value={disableAutoClose}
                  onChange={(value) => {
                    setDisableAutoClose(!disableAutoClose);
                  }}
                />

                <p
                  style={{
                    padding: 0,
                    margin: 0,
                    fontSize: 14,
                    marginLeft: 10,
                    fontWeight: "500",
                    fontFamily: "Roboto",
                  }}
                >
                  Disable Auto Close
                </p>
              </div>
              <p
                style={{
                  padding: 0,
                  margin: 0,
                  fontSize: 14,
                  color: "#888888",
                  fontFamily: "Roboto",
                  wordBreak: "break-all",
                }}
              >
                You won't be able to receive payments after this <br /> specific
                date
              </p>
            </div>
          </div>
        </div>
      )}

      <CustomButton
        loading={isLoading}
        title="Next"
        styles={{
          backgroundColor: "dodgerblue",
          height: 50,
          width: "100%",
          border: "none",
          marginTop: 20,
        }}
        onClick={() => {
          if (virtualId === "") {
            enqueueSnackbar("Please enter Virtual ID", {
              variant: "error",
            });
          } else if (bankTransferSelected && upiSelected) {
            if (userUpiDetails.length !== 0) {
              validationCheckBeforeUpi();
            } else setShowAddUpiModal(true);
          } else if (bankTransferSelected) {
            validationCheckBeforeUpi();
          } else if (upiSelected) {
            if (userUpiDetails.length !== 0) {
              validationCheckBeforeUpi();
            } else setShowAddUpiModal(true);
          } else {
            if (!bankTransferSelected && !upiSelected)
              enqueueSnackbar("Please select transfer types", {
                variant: "error",
              });
            else validationCheck();
          }
        }}
      />
      {showAddUpiModal && (
        <CustomModal
          open={showAddUpiModal}
          onClose={() => {
            setShowAddUpiModal(false);
          }}
        >
          <AddCustomerForUpiModal
            onClickSubmit={(data) => {
              setShowAddUpiModal(false);
              setUserUpiDetails(data);
            }}
            onClose={() => {
              setShowAddUpiModal(false);
            }}
          />
        </CustomModal>
      )}

      {updateVidModal && (
        <CustomModal
          open={updateVidModal}
          onClose={() => {
            setUpdateVidModal(false);
          }}
        >
          <UpdateUpiModal
            onClose={() => {
              setUpdateVidModal(false);
            }}
            onClickConfirm={(id) => {
              setShowConfirmUpiModal(true);
              setEditedUpi(id);
            }}
          />
        </CustomModal>
      )}
      {setShowConfirmUpiModal && (
        <CustomModal
          open={confirmUpiModal}
          onClose={() => {
            setShowConfirmUpiModal(false);
          }}
        >
          <UpdateConfirmUpi
            onClose={() => {
              setShowConfirmUpiModal(false);
            }}
            onClickYes={(id) => {
              setVirtualId(id);
              setUpdateVidModal(false);
              setShowConfirmUpiModal(false);
            }}
            upi={editedUpi}
          />
        </CustomModal>
      )}

      {showAddAccountModal && (
        <CustomModal
          open={showAddAccountModal}
          onClose={() => {
            setShowAddAccountModal(false);
          }}
        >
          <AddAccountModal
            onClose={() => {
              setShowAddAccountModal(false);
            }}
          />
        </CustomModal>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    allAccounts: state.addAccountsReducer.accounts,
    profileDetails: state.profileDetailsReducer.details,
  };
};

export default connect(mapStateToProps)(UpiDetails);
